import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { map, Observable, of, take } from 'rxjs';

export function createCronValidator(validateCron$: (expression: string) => Observable<boolean>): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
        const value = String(control.value ?? '').trim();

        if (!value) {
            return of(null);
        }

        const parts = value.split(/\s+/);
        if (parts.length !== 5 && parts.length !== 6) {
            return of({ cron: false });
        }

        return validateCron$(value).pipe(
            map(isValid => (isValid ? null : { cron: false })),
            take(1)
        );
    };
}
